import { ConnectedUser } from "$src/domain/realtime/ConnectedUser";
import { get, Writable, writable } from "svelte/store";

export interface TakeOverRequest {
    user: ConnectedUser;
    groupStoreId: number;
    projectId: number;
    stopTimer() : void;
}

//store for the user requesting the take over
export const takeOverDialogVisible = writable<boolean>(false);
export const autoTakeOverTimerValue = writable<number>(0);
export const isTakeOverQueryInProgress = writable<boolean>(false);

//store for the user receiving the take over request
export const requestTakeOverTimerValue = writable<number>(0);

//store for displaying take over request dialog
export const requestTakeOverVisible = writable<boolean>(false);

export const takeOverRequest = writable<TakeOverRequest | undefined>();

export function addTakeOverRequest(user: ConnectedUser, groupStoreId: number, projectId: number, autoAcceptDelayInSecond: number) {
    requestTakeOverTimerValue.set(autoAcceptDelayInSecond);

    requestTakeOverVisible.set(true);

    const timerId = setInterval(() => {
        if (get(requestTakeOverTimerValue) > 0) {
            requestTakeOverTimerValue.update((n) => n - 1);
        } else {
            clearInterval(timerId);
        }
      }, 1000);

    const request: TakeOverRequest = {
        user: user,
        groupStoreId: groupStoreId,
        projectId: projectId,
        stopTimer: () => clearInterval(timerId)
    }
  
    takeOverRequest.set(request);
}

export function clearTakeOverRequests() {

    var request = get(takeOverRequest);
    if( request )
        request.stopTimer();

    takeOverRequest.set(undefined);
    requestTakeOverVisible.set(false);
    takeOverDialogVisible.set(false);
}